import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { apiGet } from '../api/client';

const SiteSettingsContext = createContext(null);

const DEFAULTS = {
  seo: {
    titleTemplate: '{title} | ZeMaxi',
    defaultTitle: 'ZeMaxi | Twitch Streamer & Free Streaming Tools Creator',
    defaultDescription: 'ZeMaxi is a Twitch streamer and creator of free streaming tools for OBS Studio and Streamer.bot.',
    defaultKeywords: 'ZeMaxi, Twitch, streaming tools, OBS, Streamer.bot',
    defaultOgImage: 'https://zemaxi.com/images/og-image.png',
  },
  maintenance: {
    enabled: false,
    message: 'The site is temporarily offline for maintenance. Check back soon — or catch the stream on Twitch!',
  },
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet('/site/settings')
      .then((data) => {
        setSettings({
          seo: { ...DEFAULTS.seo, ...(data.seo || {}) },
          maintenance: { ...DEFAULTS.maintenance, ...(data.maintenance || {}) },
        });
      })
      .catch(() => {
        setSettings(DEFAULTS);
      })
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(() => ({ settings, loading }), [settings, loading]);

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const ctx = useContext(SiteSettingsContext);
  if (!ctx) {
    return { settings: DEFAULTS, loading: false };
  }
  return ctx;
}

export function resolveSeoTitle(pageTitle, titleTemplate, defaultTitle) {
  if (!pageTitle) {
    return defaultTitle;
  }
  const template = titleTemplate || '{title} | ZeMaxi';
  if (template.includes('{title}')) {
    return template.replace('{title}', pageTitle);
  }
  return `${pageTitle} | ${template}`;
}
